<template>
	<component :is="props.tag" :class="[props.color, props.size, props.weight]">
		<slot />
	</component>
</template>

<script setup lang="ts">
import { withDefaults } from 'vue';

const props = withDefaults(
	defineProps<{
		// tag?: keyof HTMLElementTagNameMap;
		tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p';
		color?: 'white' | 'gray';
		size?: 'xxl' | 'xl' | 'l' | 's' | 'xs';
		weight?: 'normal' | 'semi-bold' | 'bold';
	}>(),
	{
		tag: 'p',
		color: 'white',
		size: 's',
		weight: 'normal'
	}
);
</script>

<style scoped>
p {
	margin: 0;
}

h1 {
	text-align: center;
}

/* font weight */
.normal {
	font-weight: 400;
}

.semi-bold {
	font-weight: 600;
}

.bold {
	font-weight: 700;
}

/* font size */

.xxl {
	font-size: 20px;
	line-height: 26px;
}

.xl {
	font-size: 18px;
	line-height: 23px;
}

.l {
	font-size: 16px;
	line-height: 19px;
}

.s {
	font-size: 13px;
	line-height: 16px;
}

.xs {
	font-size: 11px;
	line-height: 13px;
}

/* font color */

.white {
	color: #ffffff;
}

.gray {
	color: rgba(255, 255, 255, 0.7);
}
</style>
